export default __webpack_public_path__ + "static/media/Arrow.fb15a41c.svg";